<template>
    <div class="toktokweapp-div">
        <wx-open-launch-weapp
            class="weapp"
            username="gh_14e9da81a3be"
            path="/pages/shop/index?storeId=175717576"
            @launch="handleLaunchFn"
            @error="handleErrorFn"
        >
            <script type="text/wxtag-template">
            <style>
                .weapp{
                    width: 100%;
                    height: 100%;
                    border-radius: 12px;
                    opacity: 0;
                }
                .weapp:active{
                    background: none;
                }
            </style>
            <span class="weapp">精酿商城</span>
            </script>
        </wx-open-launch-weapp>
    </div>
</template>

<script>
export default {
    name:"toktokweapp",
    props: {
        
    },
    methods:{
        handleLaunchFn(e) {
            console.log('success', e);
        },
        handleErrorFn(e) {
            console.log('fail', e.detail);
        }
    }
}
</script>

<style scoped>
/* .weapp{
    width: 80px;
    height: 24px;
    position: absolute;
    top: 0;
    left: 0;
} */

</style>


// WEBPACK FOOTER //
// src/components/toktokweapp.vue